/** Mirrors BBWT.Data.Enums.OrganisationContractTypes. */
export enum OrganisationContractTypes {
  SelfEmployed = 1,
  Contracted = 2,
  Retained = 3,
  DedicatedOnTo = 4,
  DedicatedJardine = 5,
  DedicatedBalfourBeatty = 6,
  Backstop = 7,
  Employee = 8,
  Project = 9,
}
